import { MapContainer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import MapViewport from "./MapViewport";
import type { Poi } from "./MapViewport";
import { WikientryType, Traveller } from "../modules/types";
import type { LatLngExpression } from "leaflet";
import styled from "@emotion/styled";

type Props = {
  selectedMarker: Poi | null;
  onChangeSelectedMarker: (selectedMarker: Poi | null) => void;
  searchMarker: WikientryType | null;
  onChangeSearchMarker: (searchMarker: WikientryType | null) => void;
  currentUser?: Traveller;
};

export default function Map({
  selectedMarker,
  onChangeSelectedMarker,
  searchMarker,
  onChangeSearchMarker,
  currentUser,
}: Props) {
  const DefaultStartLoc: LatLngExpression = [53.551086, 9.993682];

  if (!currentUser) return null;

  const initialCenter: LatLngExpression = currentUser.startViewpoint
    ? [currentUser.startViewpoint.lat, currentUser.startViewpoint.lon]
    : DefaultStartLoc;

  return (
    <StyledMapContainer
      center={initialCenter}
      zoom={9}
      scrollWheelZoom={false}
      style={{ width: "100%", height: "100%" }}
      zoomControl={false}
      touchZoom={true}
    >
      <MapViewport
        selectedMarker={selectedMarker}
        onChangeSelectedMarker={onChangeSelectedMarker}
        searchMarker={searchMarker}
        onChangeSearchMarker={onChangeSearchMarker}
        currentUser={currentUser}
      />
    </StyledMapContainer>
  );
}

const StyledMapContainer = styled(MapContainer)`
  width: 100%;
  height: 100%;

  .leaflet-right .leaflet-control-zoom.leaflet-bar {
    position: absolute;
    bottom: 300px;
    right: 0px;
    z-index: 1000;
  }

  /* Change zoom buttons color to blue */
  .leaflet-control-zoom-in,
  .leaflet-control-zoom-out {
    background-color: #ffffffff; /* Blue background */
    color: #4495cf; /* White + icon color */
    border: #4495cf; /* Remove default border */
  }
`;
